import {Link, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";

export const NavbarComponent = () => {

    const [ search, setSearch] = useState("");
    const navigate = useNavigate();
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const [isOpenSearch, setIsOpenSearch] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY >= 100);
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const onChangeIsOpenMenu = () => {
        setIsOpenMenu(!isOpenMenu);
        setIsOpenSearch(false);
    };
    const onChangeIsOpenSearch = () => {
        setIsOpenSearch(!isOpenSearch);
        setIsOpenMenu(false);
    };

     const onHandleSearch = (e) => {
        const target = e.target.value;
        setSearch(target)
    }

    const handleKeyPress = (event) => {
        if (event.key === "Enter" && search.trim()) {
            navigate(`/catalog?search=${encodeURIComponent(search)}`);
        }
    };

    const handleClick = (e) => {
        e.preventDefault();
        const section = document.getElementById("about-us");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        } else {
            navigate("#about-us");
        }
    };


    return(
        <nav className={"fixed top-0 z-50 w-full "}>
            <header className={"w-full"}>
                <div className={`${isScrolled ? "bg-main" : "bg-transparent"} w-full`}>
                    <div className={"w-11/12  mx-auto"} style={{maxWidth:"1500px"}}>
                        <div className={"w-full flex justify-between"}>
                            <div className={""}>
                            </div>
                            <div className={"overflow-x-auto scrollbar-hide"}>
                                <ul className={"w-max text-xs flex"}>
                                    <li className={"my-auto"}>
                                        <a href={"+622159666369"}>
                                            <div className={`my-auto  ${isScrolled ? "nav-main-hover" : "nav-main-hover-trans"}  cursor-pointer text-center`}>
                                                <p className={"font-medium"}>(+62) 21 5966 6369</p>
                                            </div>
                                        </a>
                                    </li>
                                    <li className={"my-auto"}>
                                        <a href={"https://api.whatsapp.com/send?phone=628119001211&text=Hey!%20Are%20you%20selling%20industrial%20goods.%20Can%20you%20tell%20more%20details%20about%20the%20products%20you%20sell%3F"}>
                                            <div className={`my-auto ${isScrolled ? "nav-main-hover" : "nav-main-hover-trans"} cursor-pointer text-center`}>
                                                <p className={"font-medium"}>(+62) 811 900 1211</p>
                                            </div>
                                        </a>
                                    </li>
                                    <li className={"my-auto"}>
                                        <a href={"mailto:info@unitek-indonesia.com"}>
                                            <div className={`my-auto ${isScrolled ? "nav-main-hover" : "nav-main-hover-trans"} cursor-pointer text-center`}>
                                                <p className={"font-medium"}>info@unitek-indonesia.com</p>
                                            </div>
                                        </a>
                                    </li>
                                    <li className={"my-auto"}>
                                        <Link to={"/catalog"}>
                                            <div className={`my-auto ${isScrolled ? "nav-main-hover" : "nav-main-hover-trans"} cursor-pointer text-center`}>
                                                <p className={"font-medium"}>Promosi</p>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className={"my-auto"}>
                                        <Link to={"/"}>
                                            <div className={`my-auto ${isScrolled ? "nav-main-hover" : "nav-main-hover-trans"} cursor-pointer text-center`}>
                                                <div className={"flex"}>
                                                    <div className={"flag"}>
                                                        <img src={"/assets/icon/indonesia-flag.svg"} className={"h-full rounded-sm object-cover"} alt={"indonesia flag"} />
                                                    </div>
                                                    <p className={""}>Indonesia</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={`w-full relative ${isScrolled ? "border-b border-gray-200 " : "border-b-none border-gray-none "} py-2  pt-1 ${isScrolled ? "bg-white" : "bg-transparent"} `}>
                    <div className={`w-11/12  ${isScrolled ? 'md:py-2': 'md:py-0' }   mx-auto`} style={{maxWidth:"1500px"}}>
                        <div className={"w-full  mt-5 md:mt-2 mb-5 md:mb-2  justify-between flex"}>
                            <div className={"w-7/12  flex "}>
                                <div className={"my-auto"}>
                                    <Link to={"/"}>
                                        <div className={" my-auto flex gap-2 "}>
                                            <div className={"h-8  md:h-10 md:-my-4"}>
                                                <img className={"h-full w-full my-auto object-contain"} src={`${isScrolled ? "/assets/icon/icon-logo.svg" : "/assets/icon/icon-logo-gray.svg"}`} />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className={"hidden md:block md:w-10/12 lg:w-8/12 xl:w-8/12 border-l ms-4 border-gray-400 my-auto "}>
                                    <div className={"w-10/12 ms-4 me-auto my-auto "}>
                                        <ul className={"flex  w-full mt-1.5 :text-md gap-4"}>
                                            <li className="w-3/12 my-auto relative">
                                                <Link to="/">
                                                    <div className="my-auto w-11/12 mx-auto">
                                                        <p className={` cursor-pointer  ${isScrolled ? " text-gray-600 hover:text-blue-900 after:bg-blue-900  hover:font-semibold" : " text-gray-50 after:bg-blue-50  hover:text-blue-50"}  relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:transition-all pb-1 after:duration-300 hover:after:w-full`}>
                                                            Beranda
                                                        </p>
                                                    </div>
                                                </Link>
                                            </li>
                                            <li className="w-3/12 my-auto relative">
                                                <Link to="/catalog">
                                                    <div className="my-auto w-11/12 mx-auto">
                                                        <p className={` cursor-pointer  ${isScrolled ? " text-gray-600 hover:text-blue-900 after:bg-blue-900  hover:font-semibold" : " text-gray-50 after:bg-blue-50  hover:text-blue-50"}  relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:transition-all pb-1 after:duration-300 hover:after:w-full`}>
                                                            Katalog</p>
                                                    </div>
                                                </Link>
                                            </li>
                                            <li className="w-3/12 my-auto relative">
                                                <button
                                                    onClick={() => {
                                                        const section = document.getElementById("about-us");
                                                        if (section) {
                                                            section.scrollIntoView({ behavior: "smooth" });
                                                        }
                                                    }}
                                                    className="my-auto w-11/12 mx-auto cursor-pointer"
                                                >
                                                    <p
                                                        className={`cursor-pointer ${
                                                            isScrolled
                                                                ? "text-gray-600 hover:text-blue-900 after:bg-blue-900 hover:font-semibold"
                                                                : "text-gray-50 after:bg-blue-50 hover:text-blue-50"
                                                        } relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:transition-all pb-1 after:duration-300 hover:after:w-full`}
                                                    >
                                                        Tentang
                                                    </p>
                                                </button>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className={"-my-2 ms-auto gap-1 md:gap-0 flex"}>
                                <div className={"md:flex hidden w-full md:-mt-0.5  gap-2  "}>
                                    <div className={"h-icon-search my-auto"}>
                                        <img src={"/assets/icon/icon-search.svg"}  className={"h-full my-auto object-cover"}/>
                                    </div>
                                    <input
                                        value={search}
                                        onChange={onHandleSearch}
                                        onKeyPress={handleKeyPress}
                                        className={`border-b ${isScrolled ? 'bg-white hover:text-blue-950 ' : 'bg-transparent hover:text-white'} focus:border-none active:border-none active:shadow-none focus:shadow-none border-gray-400 text-gray-600 text-sm py-2.5`}
                                        placeholder={"Cari Metal detector"}
                                    />

                                </div>
                                <div className={"w-5/12 ms-auto  block mt-0.5 md:hidden"}>
                                    <div>
                                        {isOpenSearch ? (
                                            <button onClick={onChangeIsOpenSearch} className={`w-10 sm:w-14 block ${isScrolled ? "bg-white hover:bg-gray-50 " : "bg-transparent"}  rounded-full  h-10 sm:h-14 my-auto mx-1 md:mx-2 lg:mx-2 xl:mx-4`}>
                                                <div className="h-7 sm:h-8 mx-auto">
                                                    <img className="h-full mx-auto object-cover"  src="/assets/icon/icon-menu-close.svg" alt="Menu-icon-close" />
                                                </div>
                                            </button>
                                        ) : (
                                            <button onClick={onChangeIsOpenSearch} className={`w-10 sm:w-14 block ${isScrolled ? "bg-white hover:bg-gray-50" : "bg-transparent"}  rounded-full  h-10 sm:h-14 my-auto mx-1 md:mx-2 lg:mx-2 xl:mx-4`}>
                                                <div className="h-7 sm:h-8 mx-auto">
                                                    <img className="h-full mx-auto object-cover"  src={"/assets/icon/icon-search.svg"} alt="Menu-icon-close" />
                                                </div>
                                            </button>
                                        )}

                                    </div>
                                </div>
                                <div className={"w-5/12 ms-auto  block mt-0.5 md:hidden"}>
                                    <div>
                                        {isOpenMenu ? (
                                            <button onClick={onChangeIsOpenMenu} className={`w-10 sm:w-14 block ${isScrolled ? "bg-white hover:bg-gray-50" : "bg-transparent"}  rounded-full h-10 sm:h-14 my-auto mx-1 md:mx-2 lg:mx-2 xl:mx-4`}>
                                                <div className="h-7 sm:h-8 mx-auto">
                                                    <img className="h-full mx-auto object-cover"  src="/assets/icon/icon-menu-close.svg" alt="Menu-icon-close" />
                                                </div>
                                            </button>
                                        ) : (
                                            <button onClick={onChangeIsOpenMenu} className={`w-10 sm:w-14 block ${isScrolled ? "bg-white hover:bg-gray-50" : "bg-transparent"}  rounded-full  h-10 sm:h-14 my-auto mx-1 md:mx-2 lg:mx-2 xl:mx-4`}>
                                                <div className="h-7 sm:h-8 mx-auto">
                                                    <img className="h-full mx-auto object-cover"  src="/assets/icon/icon-menu.svg" alt="Menu-icon" />
                                                </div>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {isOpenSearch && (
                        <div  className={`w-full ${isScrolled ? 'bg-white' : 'bg-transparent'} pb-3 my-auto `}>
                            <div className={"block w-11/12 mx-auto mt-7 h-full text-md gap-4"}>
                                <div className={"flex w-full :-mt-0.5  gap-2  "}>
                                    <div className={"h-icon-search my-auto"}>
                                        <img src={"/assets/icon/icon-search.svg"}  className={"h-full my-auto object-cover"}/>
                                    </div>
                                    <input
                                        value={search}
                                        onChange={onHandleSearch}
                                        onSubmit={handleKeyPress}
                                        className={`border-b  ${isScrolled ? 'bg-white text-gray-600 hover:text-blue-950 ' : 'text-white bg-transparent'}  w-full focus:border-none focus:shadow-none border-gray-400 text-md py-4`}
                                        placeholder={"What are you looking for?"}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {isOpenMenu && (
                        <div onClick={onChangeIsOpenMenu}  className={`w-full ${isScrolled ? ' bg-white h-80' : ' bg-gray-900 h-screen  pt-32 w fixed top-0 opacity-80'}  my-auto `}>
                            <ul className={"block w-full mt-16 h-full text-md gap-4"}>
                                <li className="w-full text-center py-6 my-auto relative">
                                    <Link to="/">
                                        <div className="my-auto w-11/12 mx-auto">
                                            <p className={`cursor-pointer ${isScrolled ?  'text-gray-600 hover:text-blue-950 ' : 'text-white opacity-100 '}  text-lg  my-auto relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-blue-950 after:transition-all pb-2 after:duration-300 hover:after:w-full`}>
                                                Beranda
                                            </p>
                                        </div>
                                    </Link>
                                </li>
                                <li className="w-full text-center py-6 my-auto relative">
                                <Link to="/catalog">
                                        <div className="my-auto w-11/12 mx-auto">
                                            <p className={`cursor-pointer ${isScrolled ?  'text-gray-600 hover:text-blue-950 ' : 'text-white opacity-100 '}  text-lg  my-auto relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-blue-950 after:transition-all pb-2 after:duration-300 hover:after:w-full`}>
                                                Katalog
                                            </p>
                                        </div>
                                    </Link>
                                </li>

                                <li className="w-full text-center pt-6 my-auto relative">
                                    <a
                                        href="#about-us"
                                        onClick={handleClick}
                                        className="my-auto w-11/12 mx-auto cursor-pointer"
                                    >
                                        <p
                                            className={`cursor-pointer ${
                                                isScrolled
                                                    ? "text-gray-600 hover:text-blue-950"
                                                    : "text-white opacity-100"
                                            } text-lg my-auto relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-blue-950 after:transition-all pb-2 after:duration-300 hover:after:w-full`}
                                        >
                                            Tentang
                                        </p>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    )}

                </div>
            </header>
        </nav>
    )
}


export const NavbarMainComponent = () => {

    const [ search, setSearch] = useState("");
    const navigate = useNavigate();
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const [isOpenSearch, setIsOpenSearch] = useState(false);


    const onChangeIsOpenMenu = () => {
        setIsOpenMenu(!isOpenMenu);
        setIsOpenSearch(false);
    };
    const onChangeIsOpenSearch = () => {
        setIsOpenSearch(!isOpenSearch);
        setIsOpenMenu(false);
    };

    const onHandleSearch = (e) => {
        const target = e.target.value;
        setSearch(target)
    }

    const handleKeyPress = (event) => {
        if (event.key === "Enter" && search.trim()) {
            navigate(`/catalog?search=${encodeURIComponent(search)}`);
        }
    };

    const handleClick = (e) => {
        e.preventDefault();
        const section = document.getElementById("about-us");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        } else {
            navigate("/catalog#about-us");
        }
    };

    return(
        <nav className={"fixed top-0 z-50 w-full "}>
            <header className={"w-full"}>
                <div className={` bg-main w-full`}>
                    <div className={"w-11/12  mx-auto"} style={{maxWidth:"1500px"}}>
                        <div className={"w-full flex justify-between"}>
                            <div className={""}>
                            </div>
                            <div className={"overflow-x-auto scrollbar-hide"}>
                                <ul className={"w-max text-xs flex"}>
                                    <li className={"my-auto"}>
                                        <a href={"https://api.whatsapp.com/send?phone=628119001211&text=Hey!%20Are%20you%20selling%20industrial%20goods.%20Can%20you%20tell%20more%20details%20about%20the%20products%20you%20sell%3F"}>
                                            <div className={`my-auto  nav-main-hover  cursor-pointer text-center`}>
                                                <p className={"font-medium"}>(+62) 21 5966 6369</p>
                                            </div>
                                        </a>
                                    </li>
                                    <li className={"my-auto"}>
                                        <a href={"https://api.whatsapp.com/send?phone=628119001211&text=Hey!%20Are%20you%20selling%20industrial%20goods.%20Can%20you%20tell%20more%20details%20about%20the%20products%20you%20sell%3F"}>
                                            <div className={`my-auto nav-main-hover cursor-pointer text-center`}>
                                                <p className={"font-medium"}>(+62) 811 900 1211</p>
                                            </div>
                                        </a>
                                    </li>
                                    <li className={"my-auto"}>
                                        <a href={"mailto:info@unitek-indonesia.com"}>
                                            <div className={`my-auto nav-main-hover cursor-pointer text-center`}>
                                                <p className={"font-medium"}>info@unitek-indonesia.com</p>
                                            </div>
                                        </a>
                                    </li>
                                    <li className={"my-auto"}>
                                        <Link to={"/catalog"}>
                                            <div className={`my-auto nav-main-hover cursor-pointer text-center`}>
                                            <p className={"font-medium"}>Promosi</p>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className={"my-auto"}>
                                        <button
                                            onClick={() => {
                                                const section = document.getElementById("about-us");
                                                if (section) {
                                                    section.scrollIntoView({ behavior: "smooth" });
                                                }
                                            }}
                                            className="my-auto w-11/12 mx-auto cursor-pointer"
                                        >
                                            <div className={`my-auto nav-main-hover cursor-pointer text-center`}>
                                                <div className={"flex"}>
                                                    <div className={"flag"}>
                                                        <img src={"/assets/icon/indonesia-flag.svg"} className={"h-full rounded-sm object-cover"} alt={"indonesia flag"} />
                                                    </div>
                                                    <p className={""}>Indonesia</p>
                                                </div>
                                            </div>
                                        </button>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={`w-full relative border-b border-gray-200 py-2  pt-1  bg-white `}>
                    <div className={`w-11/12  md:py-2  mx-auto`} style={{maxWidth:"1500px"}}>
                        <div className={"w-full  mt-5 md:mt-2 mb-5 md:mb-2  justify-between flex"}>
                            <div className={"w-7/12  flex "}>
                                <div className={"my-auto"}>
                                    <Link to={"/"}>
                                        <div className={" my-auto flex gap-2 "}>
                                            <div className={"h-8  md:h-10 md:-my-4"}>
                                                <img className={"h-full w-full my-auto object-contain"} src={`/assets/icon/icon-logo.svg`} />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className={"hidden md:block md:w-9/12 lg:w-8/12 xl:w-8/12 border-l ms-4 border-gray-400 my-auto "}>
                                    <div className={"w-10/12 ms-4 me-auto my-auto "}>
                                        <ul className={"flex  w-full mt-1.5 text-md gap-4"}>
                                            <li className="w-3/12 my-auto relative">
                                                <Link to="/">
                                                    <div className="my-auto w-11/12 mx-auto">
                                                        <p className={` cursor-pointer text-gray-600 hover:text-blue-900 after:bg-blue-900  hover:font-semibold relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:transition-all pb-1 after:duration-300 hover:after:w-full`}>
                                                            Beranda
                                                        </p>
                                                    </div>
                                                </Link>
                                            </li>

                                            <li className="w-3/12 my-auto relative">
                                                <Link to="/catalog">
                                                    <div className="my-auto w-11/12 mx-auto">
                                                        <p className={` cursor-pointer  text-gray-600 hover:text-blue-900 after:bg-blue-900  hover:font-semibold relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:transition-all pb-1 after:duration-300 hover:after:w-full`}>
                                                            Katalog</p>
                                                    </div>
                                                </Link>
                                            </li>
                                            <li className="w-3/12 my-auto relative">
                                                <button
                                                    onClick={handleClick}>
                                                    <div className="my-auto w-11/12 mx-auto">
                                                        <p className={` cursor-pointer text-gray-600 hover:text-blue-900 after:bg-blue-900  hover:font-semibold  relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:transition-all pb-1 after:duration-300 hover:after:w-full`}>
                                                            Tentang
                                                        </p>
                                                    </div>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className={"-my-2  gap-1 md:gap-0 flex"}>
                                <div className={"md:flex hidden w-full md:-mt-0.5  gap-2  "}>
                                    <div className={"h-icon-search my-auto"}>
                                        <img src={"/assets/icon/icon-search.svg"}  className={"h-full my-auto object-cover"}/>
                                    </div>
                                    <input
                                        value={search}
                                        onChange={onHandleSearch}
                                        onKeyPress={handleKeyPress}
                                        className={`border-b  bg-white focus:border-none active:border-none active:shadow-none focus:shadow-none border-gray-400 text-gray-600 hover:text-blue-950 text-sm py-2.5`}
                                        placeholder={"Cari Metal detector"}
                                    />

                                </div>
                                <div className={"w-5/12 block mt-0.5 md:hidden"}>
                                    <div>
                                        {isOpenSearch ? (
                                            <button onClick={onChangeIsOpenSearch} className="w-10 sm:w-14 block bg-white rounded-full hover:bg-gray-50 h-10 sm:h-14 my-auto mx-0.5 md:mx-2 lg:mx-2 xl:mx-4">
                                                <div className="h-7 sm:h-8 mx-auto">
                                                    <img className="h-full mx-auto object-cover"  src="/assets/icon/icon-menu-close.svg" alt="Menu-icon-close" />
                                                </div>
                                            </button>
                                        ) : (
                                            <button onClick={onChangeIsOpenSearch} className="w-10 sm:w-14 block bg-white rounded-full hover:bg-gray-50 h-10 sm:h-14 my-auto mx-1 md:mx-2 lg:mx-2 xl:mx-4">
                                                <div className="h-7 sm:h-8 mx-auto">
                                                    <img className="h-full mx-auto object-cover" src="/assets/icon/icon-search-blue.svg" alt="Menu-icon-close" />
                                                </div>
                                            </button>
                                        )}

                                    </div>
                                </div>
                                <div className={"w-5/12 block mt-0.5 md:hidden"}>
                                    <div>
                                        {isOpenMenu ? (
                                            <button onClick={onChangeIsOpenMenu} className="w-10 sm:w-14 block bg-white rounded-full hover:bg-gray-50 h-10 sm:h-14 my-auto mx-0.5 md:mx-2 lg:mx-2 xl:mx-4">
                                                <div className="h-7 sm:h-8 mx-auto">
                                                    <img className="h-full mx-auto object-cover"  src="/assets/icon/icon-menu-close.svg" alt="Menu-icon-close" />
                                                </div>
                                            </button>
                                        ) : (
                                            <button onClick={onChangeIsOpenMenu}  className="w-10 sm:w-14 block bg-white rounded-full hover:bg-gray-50 h-10 sm:h-14 my-auto mx-0.5 md:mx-2 lg:mx-2 xl:mx-4">
                                                <div className="h-7 sm:h-8 mx-auto">
                                                    <img className="h-full mx-auto object-cover"  src="/assets/icon/icon-menu.svg" alt="Menu-icon" />
                                                </div>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {isOpenSearch && (
                        <div className={"w-full bg-white pb-3 my-auto "}>
                            <div className={"block w-11/12 mx-auto mt-7 h-full text-md gap-4"}>
                                <div className={"flex w-full :-mt-0.5  gap-2  "}>
                                    <div className={"h-icon-search my-auto"}>
                                        <img src={"/assets/icon/icon-search.svg"}  className={"h-full my-auto object-cover"}/>
                                    </div>
                                    <input
                                        value={search}
                                        onChange={onHandleSearch}
                                        onSubmit={handleKeyPress}
                                        className={"border-b w-full focus:border-none focus:shadow-none border-gray-400 text-gray-600 hover:text-blue-950 text-md py-4"}
                                        placeholder={"What are you looking for?"}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {isOpenMenu && (
                        <div className={"w-full bg-white h-80 my-auto "}>
                            <ul className={"block w-full mt-16 h-full text-md gap-4"}>
                                <li className="w-full text-center py-6 my-auto relative">
                                    <Link to="/">
                                        <div className="my-auto w-11/12 mx-auto">
                                            <p className="cursor-pointer text-lg text-gray-600 hover:text-blue-950 my-auto relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-blue-950 after:transition-all pb-2 after:duration-300 hover:after:w-full">
                                                Beranda
                                            </p>
                                        </div>
                                    </Link>
                                </li>
                                <li className="w-full text-center py-6 my-auto relative">
                                    <Link to="/category">
                                        <div className="my-auto w-11/12 mx-auto">
                                            <p className="cursor-pointer text-lg text-gray-600 hover:text-blue-950 relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-blue-950 after:transition-all pb-2 after:duration-300 hover:after:w-full">
                                                Katalog
                                            </p>
                                        </div>
                                    </Link>
                                </li>
                                <li className="w-full text-center pt-6 my-auto relative">
                                    <button
                                        onClick={handleClick}

                                        // onClick={() => {
                                        //     const section = document.getElementById("about-us");
                                        //     if (section) {
                                        //         section.scrollIntoView({ behavior: "smooth" });
                                        //     }
                                        // }}
                                        className="my-auto w-11/12 mx-auto cursor-pointer"
                                    >
                                        <div className="my-auto w-11/12 mx-auto">
                                            <p className="cursor-pointer text-lg text-gray-600 hover:text-blue-950 relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-blue-950 after:transition-all pb-2 after:duration-300 hover:after:w-full">
                                                Tentang
                                            </p>
                                        </div>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    )}

                </div>
            </header>
        </nav>
    )
}
